var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white p-8 flex w-full"},[_c('div',{staticClass:"w-5/12 pr-8"},[_c('Plans')],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-7/12 px-5"},[_c('iframe',{staticClass:"w-full",staticStyle:{"border":"0"},attrs:{"src":"https://books.zoho.in/portal/brained","height":"610","allowfullscreen":"","loading":"lazy","referrerpolicy":"no-referrer-when-downgrade"}})])
}]

export { render, staticRenderFns }